import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import { Card, LinkedAccount, Transaction } from "model";
import React from "react";
import "./styles.css";

/**
 * @function OneTimeDetailsWidget
 * @return {React.Component}
 * @param {STRING} fiName - Sets the financial institution name.
 * @param {STRING} acctType - Sets the account type.
 * @param {STRING} lastFour - Sets the last four of the account number.
 * @param {STRING} amount - Sets the amount of the payment.
 * @param {STRING} date - Sets the date of the payment
 * @exported true
 * @description This is a shared component between the second and third step that has all the payment details.
 */
export default function OneTimeDetailsWidget(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor([ Card ,LinkedAccount,Transaction ], globalController);
   const account =  LinkedAccount.initByID(0)
    const fiName = account.fi_name ?? "[FI Name]";
    const acctType = account.type ?? "[Account Type]";
    const lastFour = account.last_four_digit_number ?? "[Account Number]";

    const amount = props.details.amount ?? "[Amount]";
    const date = props.details.date.format("M d, Y") ?? "[date]";

    return (
        <div className="one-time-details-widget">
            <div className="flex-container flex-horizontal">
                <div className="flex-width">
                    <p className="grey-label"><span>Financial Institution</span></p>
                </div>
                <div className="flex-width text-right">
                    <p><span>{fiName}</span></p>
                </div>
            </div>
            <div className="flex-container flex-horizontal">
                <div className="flex-width">
                    <p className="grey-label"><span>Account</span></p>
                </div>
                <div className="flex-width text-right capitalize">
                    <p><span>{acctType} {lastFour}</span></p>
                </div>
            </div>
            <div className="flex-container flex-horizontal">
                <div className="flex-width">
                    <p className="grey-label"><span>Amount</span></p>
                </div>
                <div className="flex-width text-right">
                    <p><span>{amount}</span></p>
                </div>
            </div>
            <div className="flex-container flex-horizontal">
                <div className="flex-width">
                    <p className="grey-label"><span>Payment Date</span></p>
                </div>
                <div className="flex-width text-right">
                    <p><span>{date}</span></p>
                </div>
            </div>
        </div>
    )
}
